import { verify } from "@/api/launcherApp/signup"
import type { TApiSignupVerifyParams, TApiSignupVerifyResponse } from "@/api/launcherApp/signup/schema"

export async function actionVerifySignup(params: TApiSignupVerifyParams): Promise<{ success: boolean; data?: TApiSignupVerifyResponse }> {
  try {
    const result = await verify(params)
    return { success: true, data: result }
  } catch (error) {
    console.error(error)
    return { success: false }
  }
}
